import { render, staticRenderFns } from "./MotorClaimForm.vue?vue&type=template&id=313c2224&scoped=true"
import script from "./MotorClaimForm.vue?vue&type=script&lang=js"
export * from "./MotorClaimForm.vue?vue&type=script&lang=js"
import style0 from "./MotorClaimForm.vue?vue&type=style&index=0&id=313c2224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c2224",
  null
  
)

export default component.exports